import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { EmailComponent } from "./EmailComponent";

interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {
 
}

export class EmailConfirmationComponent extends EmailComponent {

  constructor(props: Props) {
    super(props);

    let field = this.props.field;

    field.Script = `(field) => {
  let subsection = field.parent;
  if (subsection) {
    const ele = subsection.ListOfFormSectionElements[field.Sequence-2];
    if (ele) {
      if (ele.Value != null & field.Value != null && ele.Value != field.Value && field.Touched) {
        field.Valid = false;
        field.Touched = true;
      } else {
        field.Valid = true;
        ele.Valid = true;
      }
    }
  }
}`
  }

}